export default __webpack_public_path__ + "static/media/privilege-discount-yellow.52c67db3.svg";